// extracted by mini-css-extract-plugin
export default {"cardContentContainer":"CardContent_cardContentContainer__R1T7b"};